import MainModal from "@/components/login/main-modal";
import { useCallback } from "react";
import { useModals } from "react-easy-modals";
import { useSelector } from "react-redux";

export const useAuthGuard = () => {
  const { current_user } = useSelector((state) => state.rails);

  const modals = useModals();

  const requireAuth = useCallback(
    async (fn, ...args) => {
      if (!current_user) {
        const result = await modals.open(MainModal, { preventRedirect: true });
        if (result) {
          return fn(...args);
        }
        throw new Error("User not authenticated");
      }
      return fn(...args);
    },
    [current_user, modals]
  );

  return { requireAuth };
};
